/*
 * @Author: 张印 hbzyin@163.com
 * @Date: 2023-07-27 19:21:22
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-08-24 17:03:33
 * @FilePath: /code/mall-fe/src/views/Mobile/components/ImageRenderer.tsx
 * @Description: 根据oss资源加载图片渲染组件
 *
 */
import NoPic from 'images/cscec3b/no-pic';
import NoPicW from 'images/cscec3b/no-picw';
import { DeviceContext, RuntimeConfigurationContext } from 'libs/contexts';
import { webps } from 'libs/imgs';
import { resizeImage } from 'libs/urls';
import useUrl from 'hooks/useUrl';
import { OssConfig } from 'libs/universal';
import React, { useContext } from 'react';
import { Image } from 'react-vant';
import Link from 'next/link';
webps[NoPic] = NoPicW;

export enum ResourcesFrom {
  static = 'static',
  publicCloud = 'public-cloud',
}
interface ImageRendererProps {
  path: string;
  alt?: string;
  href?: string;
  width?: number | string;
  height?: number | string;
  lazyload?: boolean;
  thumbnail?: {
    compress: boolean;
    width: number;
    height: number;
  };
  resourcesFrom?: ResourcesFrom;
  [key: string]: any;
}

function ImageRenderer(props: ImageRendererProps) {
  const {
    path,
    alt,
    href,
    width = '100%',
    height = '100%',
    thumbnail,
    resourcesFrom,
    ...rest
  } = props;
  const { getPublicUrl } = useUrl();
  const { buildImgSrc } = useContext(DeviceContext);
  const rtCtx = useContext(RuntimeConfigurationContext);

  /**
   * @description: 创建缩略图
   * @param {string} intactPath 文件路径
   * @return {string} 缩略图地址
   */
  const createThumbnail = (intactPath: string) => {
    const ossConfig: OssConfig = {
      ossProvider: 'obs',
      publicBucketName: '',
      privateBucketName: '',
    };
    rtCtx.forEach(({ key, value }) => {
      switch (key) {
        case 'ossProvider':
          ossConfig.ossProvider = value || 'obs';
          break;
        case 'public-app-name':
          ossConfig.publicBucketName = value;
          break;
        case 'private-app-name':
          ossConfig.privateBucketName = value;
          break;
        default:
          break;
      }
    });
    // eslint-disable-next-line no-param-reassign
    intactPath = resizeImage(intactPath, thumbnail.width, thumbnail.height, ossConfig);

    return intactPath;
  };
  let intactPath;
  switch (resourcesFrom) {
    case ResourcesFrom.publicCloud:
      intactPath = getPublicUrl(path);
      break;
    case ResourcesFrom.static:
      intactPath = buildImgSrc(path);
    default:
      intactPath = path;
      break;
  }

  if (
    thumbnail?.compress &&
    !intactPath.includes('static-tg.tabe.cn') &&
    !intactPath.includes('static-tg.3jyx.cn')
  ) {
    intactPath = createThumbnail(intactPath);
  }

  const createEmptyEle = () => {
    return React.createElement('img', {
      src: buildImgSrc(NoPic),
      width,
      height,
      alt,
    });
  };
  const imageEle = (
    <Image
      src={intactPath}
      alt={rest.alt}
      loadingIcon={createEmptyEle()}
      errorIcon={createEmptyEle()}
      {...rest}
    />
  );

  if (href) {
    return (
      <Link href={href}>
        <a>{imageEle}</a>
      </Link>
    );
  }
  return imageEle;
}

export default ImageRenderer;
